import { RealAssetType } from './RealAssetType';

export const isEquityAsset = (typename: string) =>
  Object.values(RealAssetType).includes(typename as RealAssetType);
